import { render, staticRenderFns } from "./index.vue?vue&type=template&id=090d6ef0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=090d6ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d6ef0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoreLink: require('D:/Project/kpwebsite/PC/components/moreLink/index.vue').default})
